/**
 * Internal dependencies
 */
import type { Attributes } from '../../../../../../packages/segmentation-rule-library/rules/language/types';

export const type = 'nab/language';

export function validate( attributes: Attributes ): boolean {
	const { condition, language } = attributes;

	const currentLanguages = window.navigator.languages.map( ( l ) =>
		l.toLowerCase()
	);
	const hasLanguage = ( expected: string ) =>
		currentLanguages.some( ( actual ) => actual.startsWith( expected ) );

	switch ( condition ) {
		case 'is-equal-to':
			return language.some( ( { value } ) => hasLanguage( value ) );

		case 'is-not-equal-to':
			return ! language.some( ( { value } ) => hasLanguage( value ) );
	}
}
